module.exports={
	"Form": "LotCreateManifest",
	"Scope": "Lot-Create",
	"Descriptors":
	{
		"LotDetails.Name":
		{
			"Name": "Name",
			"Hash": "Lot-Create-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "1",
				"Width": 6,
				"Section": "Lot-Create-Identity",
				"Group": "Lot-Create-Identity"
			}
		},
		"LotDetails.StartDate":
		{
			"Name": "Start Date",
			"Hash": "Lot-Create-StartDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "2",
				"Width": 4,
				"Section": "Lot-Create-Details",
				"Group": "Lot-Create-Details"
			}
		},
		"LotDetails.FormData":
		{
			"Name": "Form Data",
			"Hash": "Lot-Create-FormData",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "2",
				"Width": 4,
				"Section": "Lot-Create-Details",
				"Group": "Lot-Create-Details"
			}
		},
		"LotDetails.IDMixDesign":
		{
			"Name": "Mix Design",
			"Hash": "Lot-Create-IDMixDesign",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "2",
				"Width": 4,
				"Section": "Lot-Create-Details",
				"Group": "Lot-Create-Details",
				"Entity": "MixDesign",
				"SearchFields":
				[
					"MaterialCode",
					"Name",
					"Description"
				]
			}
		},
		"LotDetails.IDContract":
		{
			"Name": "Contract",
			"Hash": "Lot-Create-IDContract",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "3",
				"Width": 4,
				"Section": "Lot-Create-Details",
				"Group": "Lot-Create-Details",
				"Entity": "Contract",
				"SearchFields":
				[
					"Name",
					"Description",
					"PrimaryProjectNumber",
					"CountyProjectNumber"
				]
			}
		},
		"LotDetails.ValidationSequence":
		{
			"Name": "Validation Sequence",
			"Hash": "Lot-Create-ValidationSequence",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "3",
				"Width": 4,
				"Section": "Lot-Create-Details",
				"Group": "Lot-Create-Details"
			}
		},
		"LotDetails.LPSyncDate":
		{
			"Name": "LPSync Date",
			"Hash": "Lot-Create-LPSyncDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "3",
				"Width": 4,
				"Section": "Lot-Create-Details",
				"Group": "Lot-Create-Details"
			}
		},
		"LotDetails.HLSyncDate":
		{
			"Name": "HLSync Date",
			"Hash": "Lot-Create-HLSyncDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "4",
				"Width": 4,
				"Section": "Lot-Create-Details",
				"Group": "Lot-Create-Details"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "Lot-Create-Identity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "Lot-Create-Identity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Details",
			"Hash": "Lot-Create-Details",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Details",
					"Hash": "Lot-Create-Details",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}
